/*
 *
 * Team Members constants
 *
 */

export const TEAM_MEMBERS_CHANGE = 'src/TeamMembers/TEAM_MEMBERS_CHANGE';
export const TEAM_MEMBERS_EDIT_CHANGE = 'src/TeamMembers/TEAM_MEMBERS_EDIT_CHANGE';
export const TEAM_MEMBERS_ADD = 'src/TeamMembers/TEAM_MEMBERS_ADD';
export const TEAM_MEMBERS_DELETE = 'src/TeamMembers/TEAM_MEMBERS_DELETE';
export const TEAM_MEMBERS_GET = 'src/TeamMembers/TEAM_MEMBERS_GET';
export const TEAM_MEMBERS_GET_ALL = 'src/TeamMembers/TEAM_MEMBERS_GET_ALL';
export const TEAM_MEMBERS_RESET = 'src/TeamMembers/TEAM_MEMBERS_RESET';
export const SET_TEAM_MEMBERS_LOADING = 'src/TeamMembers/SET_TEAM_MEMBERS_LOADING';
export const SET_TEAM_MEMBERS_SUBMITTING = 'src/TeamMembers/SET_TEAM_MEMBERS_SUBMITTING';
export const SET_TEAM_MEMBERS_FORM_ERRORS = 'src/TeamMembers/SET_TEAM_MEMBERS_FORM_ERRORS';
export const SET_TEAM_MEMBERS_FORM_EDIT_ERRORS = 'src/TeamMembers/SET_TEAM_MEMBERS_FORM_EDIT_ERRORS';
